const defaultSettings = undefined;
export const getThankYouPageSettings = clientData => {
  if (!clientData?.thankYouPageSettings) {
    return defaultSettings;
  }
  try {
    const stored = JSON.parse(clientData.thankYouPageSettings);
    const parsed = {
      title: stored?.title,
      message: stored?.message,
      buttonText: stored?.buttonText,
      buttonLink: stored?.buttonLink
    };
    if (parsed.title || parsed.message || parsed.buttonText) {
      return parsed;
    }
    return defaultSettings;
  } catch {
    return defaultSettings;
  }
};
export const hasButtonLink = settings => {
  return Boolean(settings?.buttonLink);
};
export const isDefaultThankYouPageSettings = settings => {
  return settings === undefined;
};
//# sourceMappingURL=get-thank-you-page-settings.js.map